import moment from 'moment';
import { GqlTimeRange } from 'types/graphql';

export type Day = {
  key: number;
  dayName: string;
  startTime: string;
  endTime: string;
  allDay: boolean;
  enabled: boolean;
};

/**
 * Checks if the given time range represents a full 24-hour day
 * @param startTime - Start time in HH:mm format
 * @param endTime - End time in HH:mm format
 * @returns True if the times represent midnight to midnight (all day)
 */
export function isAllDay(startTime: string, endTime: string): boolean {
  return startTime === '00:00' && endTime === '23:59';
}

export function createScheduleTemplate(timeRanges?: GqlTimeRange[] | null, enableByDefault = true): Day[] {
  const d = { startTime: '09:00 AM', endTime: '05:00 PM', allDay: true, enabled: enableByDefault };
  let days = [
    { key: 1, dayName: `Monday`, ...d },
    { key: 2, dayName: `Tuesday`, ...d },
    { key: 3, dayName: `Wednesday`, ...d },
    { key: 4, dayName: `Thursday`, ...d },
    { key: 5, dayName: `Friday`, ...d },
    { key: 6, dayName: `Saturday`, ...d },
    { key: 0, dayName: `Sunday`, ...d },
  ];

  // for every day in the day array, if there is a time range in the schedule for that day, use the time range
  // otherwise, use the default time range
  if (timeRanges) {
    days = days.map((day) => {
      const timeRange = timeRanges.find((tr) => tr.dayOfWeek === day.key);
      if (timeRange) {
        return {
          ...day,
          startTime: timeRange.startTime,
          endTime: timeRange.endTime,
          allDay: isAllDay(timeRange.startTime, timeRange.endTime),
          enabled: true,
        };
      }
      return { ...day, enabled: false };
    });
  }
  return days;
}

export function getTimeDisplayString(startTime: string, endTime: string): string {
  return startTime === moment().startOf('day').format('HH:mm') && endTime === moment().endOf('day').format('HH:mm')
    ? 'All Day'
    : `${moment(startTime, 'HH:mm A').format('h:mm A')} - ${moment(endTime, 'HH:mm A').format('h:mm A')}`;
}
